import includes from 'lodash/includes'

import { instanceName as applicationInstanceName } from '../../ApplicationSearchGeneral/constants'
import { RF_NAME as collaterInstanceName } from '../../CollateralSearch/constants'
import { RF_NAME as loanInstanceName } from '../../LoanSearch/constants'
import { instanceName as clientInstanceName } from '../../ClientSearchGeneral/constants'

export const searchSwitchType = (searchValue, searchType, instanceName = null) => {
  let fieldValue
  /* eslint-disable no-restricted-globals */

  if (!searchValue) {
    fieldValue = '0'
  } else if (!searchType) {
    if (isNaN(searchValue[0])) {
      fieldValue = '0'
    } else if (instanceName === loanInstanceName) {
      fieldValue = '2'
    } else {
      fieldValue = '1'
    }
  } else if (searchType === '0' || searchType === 0) {
    if (!isNaN(searchValue[0])) {
      fieldValue = instanceName === loanInstanceName ? '2' : '1'
    }
  } else if (searchType === '1') {
    if (isNaN(searchValue[0])) {
      fieldValue = '0'
    }
  } else if (searchType === '2') {
    if (
      includes([applicationInstanceName, collaterInstanceName, loanInstanceName], instanceName) &&
      isNaN(searchValue[0])
    ) {
      fieldValue = '0'
    } else if (instanceName === clientInstanceName && searchValue.length > 5 && !isNaN(searchValue)) {
      fieldValue = '1'
    }
  }

  return fieldValue
}
